interface ReloadButtonProps {
    onClick: () => void;
    id: string;
}

export const ReloadButton: React.FC<ReloadButtonProps> = ({ onClick, id }) => {
    return (
        <a
            onClick={(e) => {
                e.preventDefault();
                onClick();
            }}
            id={`${id}-reload-btn`}
            className="link-primary p-0"
        >
            <em className="icon ni ni-reload cursor-pointer" />
        </a>
    );
};
